import { AbstractControl } from '@angular/forms';

export class ConfirmPasswordValidator {
  static PASSWORD_MIN_LENGTH = 8;
  /**
   * Check matching password with confirm password
   * @param control AbstractControl
   */
  static MatchPassword(control: AbstractControl): void {
    const password = control.get('new_password')?.value;
    const confirmPassword = control.get('confirm_password')?.value;

    if (password !== confirmPassword) {
      control.get('confirm_password')?.setErrors({ ConfirmPassword: true });
    }
  }

  static PasswordLength(control: AbstractControl): void {
    const password = control.get('new_password')?.value;
    if (password && password.length < ConfirmPasswordValidator.PASSWORD_MIN_LENGTH) {
      control.get('new_password')?.setErrors({ MinLength: true });
    }
  }
}
